import React from 'react';
import theme from 'shared/constants/theme.json';
import { HolderOutlined } from '@ant-design/icons';

const DragHandle = () => (
  <HolderOutlined style={{ color: theme['text-color-secondary'], cursor: 'move' }} className="drag-handle" />
);

export default DragHandle;
